import React from "react";
import PlaceTable from "../../components/tables/PlaceTable";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import {Box, Button, Typography } from "@mui/material";


const MainPlacePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Box
        sx={{
          mb: 4,
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{
            position: "absolute",
            left: 16,
          }}
          startIcon={<AddIcon />}
          onClick={() => navigate("create")}
        >
          Create Place
        </Button>
        <Typography variant="h1">Places</Typography>
      </Box>
      <PlaceTable />
    </Box>
  );
};

export default MainPlacePage;
